import React, { ReactElement } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import { MarkdownWrapper } from './markdown.styles';

export interface MarkdownProps {
  children: string;
  components?: Components;
  whiteSpace?: 'nowrap';
}

export const Markdown = ({
  children,
  components,
  whiteSpace,
}: MarkdownProps): ReactElement => {
  return (
    <MarkdownWrapper whiteSpace={whiteSpace}>
      <ReactMarkdown components={components}>{children}</ReactMarkdown>
    </MarkdownWrapper>
  );
};
